<div class="register-page">
  <div class="page-bg"></div>
  <div class="page-scrim"></div>
  <div class="orb orb--one"></div>
  <div class="orb orb--two"></div>
  <div class="orb orb--three"></div>
  <div class="grid-overlay"></div>

  <div class="register-content">
    @if (step() === 'success') {
      <div class="glass-card glass-card--success">
        <div class="success-icon">
          <span class="material-icons">check</span>
        </div>
        <h1>You're all set</h1>
        <p>{{ successMessage() }}</p>
        <a routerLink="/login" class="submit-btn">
          <span>Back to login</span>
          <span class="material-icons">arrow_forward</span>
        </a>
      </div>
    }

    @if (step() === 'credentials') {
      <form class="glass-card" (ngSubmit)="submitCredentials()" #credentialsForm="ngForm">
        <div class="glass-card__header">
          <div class="brand">
            <div class="logo-mark">
              <img src="/itrace-logo.jpeg" alt="iTrace" />
            </div>
            <span class="brand-name">iTrace</span>
          </div>
          <h1>Register via the itrace portal</h1>
          <p>Step 1 of 3 — verify your itrace account to see the companies you belong to</p>
        </div>

        <div class="form-grid form-grid--single">
          <div class="field">
            <div class="field__control">
              <span class="material-icons field__icon">mail_outline</span>
              <input
                type="email"
                name="email"
                [(ngModel)]="credentials.email"
                required
                autocomplete="username"
                placeholder=" "
                id="credEmail"
              />
              <label for="credEmail">itrace email</label>
            </div>
          </div>

          <div class="field">
            <div class="field__control">
              <span class="material-icons field__icon">lock_outline</span>
              <input
                [type]="showPassword() ? 'text' : 'password'"
                name="password"
                [(ngModel)]="credentials.password"
                required
                autocomplete="current-password"
                placeholder=" "
                id="credPassword"
              />
              <label for="credPassword">itrace password</label>
              <button
                type="button"
                class="field__toggle"
                (click)="togglePasswordVisibility()"
                [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
              >
                <span class="material-icons">{{ showPassword() ? 'visibility_off' : 'visibility' }}</span>
              </button>
            </div>
          </div>
        </div>

        @if (errorMessage()) {
          <p class="error">
            <span class="material-icons">error_outline</span>
            {{ errorMessage() }}
          </p>
        }

        <button type="submit" class="submit-btn" [disabled]="credentialsForm.invalid || isSubmitting()">
          @if (isSubmitting()) {
            <span class="spinner"></span>
            <span>Verifying...</span>
          } @else {
            <span>Continue</span>
            <span class="material-icons">arrow_forward</span>
          }
        </button>

        <div class="glass-card__footer">
          <span>Already have an account?</span>
          <a routerLink="/login">Back to login</a>
        </div>
      </form>
    }

    @if (step() === 'pick-company') {
      <div class="glass-card glass-card--wide">
        <div class="glass-card__header">
          <div class="brand">
            <div class="logo-mark">
              <img src="/itrace-logo.jpeg" alt="iTrace" />
            </div>
            <span class="brand-name">iTrace</span>
          </div>
          <h1>Choose a company</h1>
          <p>Step 2 of 3 — pick which of your itrace companies to register on this platform</p>
        </div>

        @if (errorMessage()) {
          <p class="error">
            <span class="material-icons">error_outline</span>
            {{ errorMessage() }}
          </p>
        }

        @if (companies().length === 0) {
          <p class="empty-note">No companies were found on this itrace account.</p>
        }

        <div class="company-list">
          @for (company of companies(); track company.id) {
            <button type="button" class="company-card" (click)="selectCompany(company)">
              <div class="company-card__main">
                <span class="company-card__name">{{ company.companyName }}</span>
                @if (company.parent) {
                  <span class="company-card__uuid">Under {{ company.parent.title }}</span>
                }
              </div>
              <div class="company-card__badges">
                @if (company.registered) {
                  <span class="badge badge--registered">
                    <span class="material-icons">check_circle</span>
                    Already registered
                  </span>
                } @else {
                  <span class="badge badge--new">New</span>
                }
                @for (role of company.roles; track role.id) {
                  <span class="badge">{{ role.role }}</span>
                }
              </div>
              <span class="material-icons company-card__arrow">chevron_right</span>
            </button>
          }
        </div>

        <div class="glass-card__footer">
          <a (click)="backToCredentials()">Back</a>
        </div>
      </div>
    }

    @if (step() === 'confirm-account') {
      <form class="glass-card" (ngSubmit)="submitRegistration()" #confirmAccountForm="ngForm">
        <div class="glass-card__header">
          <div class="brand">
            <div class="logo-mark">
              <img src="/itrace-logo.jpeg" alt="iTrace" />
            </div>
            <span class="brand-name">iTrace</span>
          </div>
          <h1>Join {{ selectedCompany()?.companyName }}</h1>
          <p>Step 3 of 3 — this company is already registered, so your account is created instantly</p>
        </div>

        <div class="form-grid form-grid--single">
          <div class="field">
            <div class="field__control">
              <span class="material-icons field__icon">person_outline</span>
              <input
                name="adminFullName"
                [(ngModel)]="form.admin.fullName"
                required
                maxlength="200"
                placeholder=" "
                id="caFullName"
              />
              <label for="caFullName">Your full name</label>
            </div>
          </div>

          <div class="field">
            <div class="locked-field">
              <span class="material-icons">verified_user</span>
              <div>
                <span class="locked-field__label">itrace account</span>
                <span class="locked-field__value">{{ form.admin.email }}</span>
              </div>
            </div>
          </div>
        </div>

        @if (adminEmailError()) {
          <p class="error">
            <span class="material-icons">error_outline</span>
            {{ adminEmailError() }}
          </p>
        }
        @if (errorMessage()) {
          <p class="error">
            <span class="material-icons">error_outline</span>
            {{ errorMessage() }}
          </p>
        }

        <button type="submit" class="submit-btn" [disabled]="confirmAccountForm.invalid || isSubmitting()">
          @if (isSubmitting()) {
            <span class="spinner"></span>
            <span>Creating your account...</span>
          } @else {
            <span>Create my account</span>
            <span class="material-icons">arrow_forward</span>
          }
        </button>

        <div class="glass-card__footer">
          <a (click)="backToCompanyList()">Back</a>
        </div>
      </form>
    }

    @if (step() === 'details') {
      <form class="glass-card glass-card--wide" (ngSubmit)="submitRegistration()" #detailsForm="ngForm">
        <div class="glass-card__header">
          <div class="brand">
            <div class="logo-mark">
              <img src="/itrace-logo.jpeg" alt="iTrace" />
            </div>
            <span class="brand-name">iTrace</span>
          </div>
          <h1>Confirm company details</h1>
          <p>Step 3 of 3 — review and complete the details carried over from {{ selectedCompany()?.companyName }}</p>
        </div>

        <div class="section-label">
          <span class="material-icons">apartment</span>
          Company details
        </div>

        <div class="form-grid">
          <div class="field">
            <div class="field__control">
              <span class="material-icons field__icon">business</span>
              <input name="name" [(ngModel)]="form.name" required maxlength="200" placeholder=" " id="pName" />
              <label for="pName">Company name</label>
            </div>
          </div>

          <div class="field">
            <div class="field__control">
              <span class="material-icons field__icon">badge</span>
              <input
                name="registrationNo"
                [(ngModel)]="form.registrationNo"
                required
                maxlength="100"
                placeholder=" "
                id="pRegistrationNo"
              />
              <label for="pRegistrationNo">Registration number</label>
            </div>
          </div>

          <div class="field">
            <app-country-select
              name="countryCode"
              [(ngModel)]="form.countryCode"
              required
              variant="glass"
              icon="public"
              label="Country"
            />
          </div>

          <div class="field">
            <div class="field__control">
              <span class="material-icons field__icon">mail_outline</span>
              <input
                type="email"
                name="contactEmail"
                [(ngModel)]="form.contactEmail"
                required
                maxlength="255"
                placeholder=" "
                id="pContactEmail"
              />
              <label for="pContactEmail">Contact email</label>
            </div>
          </div>

          <div class="field">
            <div class="field__control">
              <span class="material-icons field__icon">call</span>
              <input
                name="contactPhone"
                [(ngModel)]="form.contactPhone"
                maxlength="50"
                placeholder=" "
                id="pContactPhone"
              />
              <label for="pContactPhone">Contact phone (optional)</label>
            </div>
          </div>

          <div class="field">
            <div class="field__control">
              <span class="material-icons field__icon">place</span>
              <input name="address" [(ngModel)]="form.address" maxlength="500" placeholder=" " id="pAddress" />
              <label for="pAddress">Address (optional)</label>
            </div>
          </div>
        </div>

        <div class="section-label">
          <span class="material-icons">badge</span>
          Your account
        </div>

        <div class="form-grid">
          <div class="field">
            <div class="field__control">
              <span class="material-icons field__icon">person_outline</span>
              <input
                name="adminFullName"
                [(ngModel)]="form.admin.fullName"
                required
                maxlength="200"
                placeholder=" "
                id="pFullName"
              />
              <label for="pFullName">Your full name</label>
            </div>
          </div>

          <div class="field">
            <div class="locked-field">
              <span class="material-icons">verified_user</span>
              <div>
                <span class="locked-field__label">itrace account</span>
                <span class="locked-field__value">{{ form.admin.email }}</span>
              </div>
            </div>
          </div>
        </div>

        @if (adminEmailError()) {
          <p class="error">
            <span class="material-icons">error_outline</span>
            {{ adminEmailError() }}
          </p>
        }
        @if (errorMessage()) {
          <p class="error">
            <span class="material-icons">error_outline</span>
            {{ errorMessage() }}
          </p>
        }

        <button type="submit" class="submit-btn" [disabled]="detailsForm.invalid || isSubmitting()">
          @if (isSubmitting()) {
            <span class="spinner"></span>
            <span>Registering...</span>
          } @else {
            <span>Complete registration</span>
            <span class="material-icons">arrow_forward</span>
          }
        </button>

        <div class="glass-card__footer">
          <a (click)="backToCompanyList()">Back</a>
        </div>
      </form>
    }
  </div>
</div>
